import PropTypes from 'prop-types';
import React from 'react';

import Image from '../../components/ContentfulImage';

import {
  Section,
  Container,
  Item,
  ImageWrapper,
  TextContainer,
  ItemTitle,
  ItemDescription,
  Title,
  Procedure,
} from './StylesLooksHowto.style';
import Placeholder from '../Placeholder';

const StylesLooksHowto = ({ procedure }) => (
  <Section>
    {procedure.map(proc => (
      <Procedure key={proc.name || proc.key}>
        <Title>{proc.name || <Placeholder w="100px" h="20px" />}</Title>
        <Container>
          {proc.steps.map(({ description, image, key, name }) => (
            <Item key={name || key}>
              <ItemTitle>{name || <Placeholder w="50px" h="20px" />}</ItemTitle>
              <ImageWrapper>
                {image ? (
                  <Image src={image} options={{ w: '100%', size: [550, 850, 350] }} />
                ) : (
                  <Placeholder w="100%" pb="calc(1100% / 14)" />
                )}
              </ImageWrapper>
              <TextContainer>
                <ItemDescription>{description || <Placeholder w="100%" h="40px" />}</ItemDescription>
              </TextContainer>
            </Item>
          ))}
        </Container>
      </Procedure>
    ))}
  </Section>
);

StylesLooksHowto.defaultProps = {
  procedure: [
    { key: 1, steps: [{ key: 1 }, { key: 2 }, { key: 3 }] },
    { key: 2, steps: [{ key: 1 }, { key: 2 }, { key: 3 }] },
  ],
};

StylesLooksHowto.propTypes = {
  procedure: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      steps: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          items: PropTypes.arrayOf(PropTypes.shape({})),
        })
      ),
    })
  ),
};

export default StylesLooksHowto;



// WEBPACK FOOTER //
// ./src/components/StylesLooksHowto/StylesLooksHowto.js